(function () {
  'use strict';

  var SELECTORS = {
    drawer: '[data-cart-drawer]',
    close: '[data-cart-drawer-close]',
    title: '[data-cart-drawer-title]',
    itemsContainer: '[data-cart-items]',
    footer: '[data-cart-footer]',
    subtotal: '[data-cart-subtotal]',
    countBadge: '[data-cart-count]',
    headerCount: '.cart-count',
    progressFill: '[data-progress-fill]',
    progressText: '[data-progress-text]',
    productForm: '[data-product-form], form[action$="/cart/add"], form[action*="/cart/add"]',
    addToCartBtn: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    collectionCardAtc: '[data-collection-atc]',
    cartToggle: '.site-header__cart-toggle',
    quantityButton: '[data-cart-quantity-change]',
    removeButton: '[data-cart-remove]'
  };

  var state = {
    cart: null,
    open: false,
    loading: false,
    trigger: null
  };

  function drawerEl() {
    return document.querySelector(SELECTORS.drawer);
  }

  function config() {
    var el = drawerEl();
    if (!el) return {};

    return {
      threshold: parseInt(el.getAttribute('data-free-delivery-threshold'), 10) || 0,
      titleCart: el.getAttribute('data-title-cart') || 'Your bag',
      progressPending: el.getAttribute('data-progress-pending') || '',
      progressComplete: el.getAttribute('data-progress-complete') || '',
      autoOpen: el.getAttribute('data-auto-open-cart-drawer') === 'true',
      // Gift with purchase (see computeGwp)
      gwpThreshold: parseInt(el.getAttribute('data-gwp-threshold'), 10) || 0,
      gwpEligibleIds: (el.getAttribute('data-gwp-eligible-ids') || '')
        .split(',')
        .map(function (id) { return parseInt(id, 10); })
        .filter(function (id) { return !isNaN(id); }),
      gwpShopUrl: el.getAttribute('data-gwp-shop-url') || '/collections/all',
      gwpShopLabel: el.getAttribute('data-gwp-shop-label') || 'Shop all devices',
      gwpTitle: el.getAttribute('data-gwp-title') || 'Your free gift: {count} items',
      gwpLockedMeta: el.getAttribute('data-gwp-locked-meta') || '',
      gwpUnlockedMeta: el.getAttribute('data-gwp-unlocked-meta') || '',
      gwpPending: el.getAttribute('data-gwp-pending') || '',
      gwpComplete: el.getAttribute('data-gwp-complete') || '',
      gwpGuard: el.getAttribute('data-gwp-guard') || '',
      gwpRemoveLabel: el.getAttribute('data-gwp-remove-label') || 'Remove gift bundle'
    };
  }

  // "£86.00" reads as "£86" in running copy; keep pence only when they matter.
  function formatMoneyShort(cents) {
    return formatMoney(cents).replace(/([.,]00)(?!\d)/, '');
  }

  function fillTemplate(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties._gwp);
  }

  // App-managed gifts (geske-gwp-engine.js) also use _gwp, but their value is
  // a published rule handle; the engine tells legacy and managed lines apart.
  // Null when no rules are published, so everything below falls back to the
  // legacy landing-page bundle behaviour.
  function engine() {
    return window.GeskeGwp && window.GeskeGwp.config() ? window.GeskeGwp : null;
  }

  /* Gift with purchase (UK launch free bundle).
   * Gift lines carry a _gwp line property whose value is the discount code.
   * The bundle is "provisional": it sits in the bag at full price until the
   * customer's spend on the eligible collection reaches the threshold, at which
   * point the BXGY code zeroes the gift lines. Everything the drawer, the offer
   * bar and the PDP card say about the gift derives from this one summary. */
  function computeGwp(cart) {
    var cfg = config();
    var items = (cart && cart.items) || [];
    // Rule-driven gifts are evaluated by the engine (single predicate for the
    // drawer, /cart page and the offer bar); this function keeps owning the
    // legacy landing-page bundle and merges both for rendering.
    var gwpEngine = engine();
    var ev = gwpEngine ? gwpEngine.evaluate(cart) : null;
    var giftLines = ev ? ev.legacyLines : items.filter(isGiftLine);
    var paidLines = ev
      ? ev.paidLines.concat(ev.configuredGiftLines)
      : items.filter(function (item) { return !isGiftLine(item); });
    var managedQty = ev ? ev.managedLines.reduce(function (sum, item) { return sum + (item.quantity || 0); }, 0) : 0;

    if (!giftLines.length) {
      return {
        active: false,
        giftLines: [],
        paidLines: paidLines,
        paidCount: cart ? Math.max(0, cart.item_count - managedQty) : 0,
        engine: ev
      };
    }

    var eligible = cfg.gwpEligibleIds;
    var eligibleSpend = paidLines.reduce(function (sum, item) {
      if (eligible.length && eligible.indexOf(item.product_id) === -1) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
    var giftValue = giftLines.reduce(function (sum, item) { return sum + (item.original_line_price || 0); }, 0);
    var giftCharge = giftLines.reduce(function (sum, item) { return sum + (item.final_line_price || 0); }, 0);
    var giftCount = giftLines.reduce(function (sum, item) { return sum + (item.quantity || 0); }, 0);
    var paidCount = paidLines.reduce(function (sum, item) { return sum + (item.quantity || 0); }, 0);
    var threshold = cfg.gwpThreshold;
    var remaining = Math.max(0, threshold - eligibleSpend);
    var code = giftLines[0].properties._gwp;
    var codeAttached = (cart.discount_codes || []).some(function (entry) {
      return entry && entry.code && String(entry.code).toLowerCase() === String(code).toLowerCase();
    });

    return {
      active: true,
      engine: ev,
      code: typeof code === 'string' ? code : '',
      codeAttached: codeAttached,
      giftLines: giftLines,
      paidLines: paidLines,
      giftCount: giftCount,
      paidCount: paidCount,
      giftValue: giftValue,
      giftCharge: giftCharge,
      eligibleSpend: eligibleSpend,
      threshold: threshold,
      remaining: remaining,
      unlocked: threshold > 0 && eligibleSpend >= threshold,
      progress: threshold > 0 ? Math.max(0, Math.min(100, (eligibleSpend / threshold) * 100)) : 100,
      shopUrl: cfg.gwpShopUrl,
      shopLabel: cfg.gwpShopLabel,
      // Pre-formatted for message templates
      values: {
        amount: formatMoneyShort(remaining),
        value: formatMoneyShort(giftValue),
        threshold: formatMoneyShort(threshold),
        count: String(giftCount)
      }
    };
  }

  function broadcast(gwp) {
    try {
      document.dispatchEvent(new CustomEvent('geske:cart', {
        bubbles: false,
        detail: { cart: state.cart, gwp: gwp, engine: gwp && gwp.engine ? gwp.engine : null }
      }));
    } catch (error) {
      /* no-op */
    }
  }

  function shopCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  }

  function formatMoney(cents) {
    var gwpEngine = engine();
    var format = (window.theme && window.theme.moneyFormat) ||
      (gwpEngine && gwpEngine.config() && gwpEngine.config().moneyFormat) || '';
    var value = (cents / 100).toFixed(2);
    var valueNoDecimals = Math.round(cents / 100).toString();

    if (format && format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', valueNoDecimals);
    }

    if (format && format.indexOf('{{amount}}') !== -1) {
      return format.replace('{{amount}}', value);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: shopCurrency()
      }).format(cents / 100);
    } catch (error) {
      return value + ' ' + shopCurrency();
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        state.cart = cart;
        return cart;
      });
  }

  // Serialize every cart mutation. A boolean in-flight guard would silently
  // drop a second add (e.g. tapping two cards quickly, or add-then-change)
  // while the first /cart/add.js + /cart.js round-trip is pending, which is a
  // prime cause of "it won't let me add more than one". Chaining instead means
  // every request is processed in order and none are lost.
  var opQueue = Promise.resolve();

  function enqueue(task) {
    // Share the gift engine's queue when it is present so gift add/remove and
    // customer clicks are serialised together.
    if (window.GeskeGwp && window.GeskeGwp.enqueue) return window.GeskeGwp.enqueue(task);
    var run = opQueue.then(task, task);
    opQueue = run.catch(function () {});
    return run;
  }

  // Let the gift engine bring the cart to its desired state (add/remove/swap
  // gift lines) after every paint. Never awaited inside a queued task, so it
  // cannot deadlock the shared queue; a mutation simply triggers a re-render,
  // whose own settle() finds nothing to do.
  function settle() {
    var gwpEngine = engine();
    if (!gwpEngine || !state.cart || state.settling) return;
    state.settling = true;
    gwpEngine.reconcile(state.cart)
      .then(function (result) {
        state.settling = false;
        if (result && result.mutated && result.cart) {
          state.cart = result.cart;
          render();
          updateHeaderBadge();
        }
      })
      .catch(function () { state.settling = false; });
  }

  function addItem(variantId, quantity) {
    return enqueue(function () {
      state.loading = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(fetchCart)
        .then(function () {
          // The item is already in the cart here, so a render/open exception
          // must not be reported back as an add failure.
          try {
            render();
            openDrawer();
          } catch (renderError) {
            /* drawer hydration failed, but the add succeeded */
          }
          try {
            updateHeaderBadge();
          } catch (badgeError) {
            /* no-op */
          }
          return true;
        })
        .catch(function (error) {
          handleError(error);
          return false;
        })
        .finally(function () {
          state.loading = false;
        });
    });
  }

  function changeItem(lineKey, quantity) {
    return enqueue(function () {
      var drawer = drawerEl();
      state.loading = true;
      if (drawer) drawer.classList.add('is-updating');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw error;
            });
          }

          return response.json();
        })
        .then(function (cart) {
          state.cart = cart;
          render();
          updateHeaderBadge();
          return cart;
        })
        .catch(handleError)
        .finally(function () {
          state.loading = false;
          if (drawer) drawer.classList.remove('is-updating');
        });
    });
  }

  function handleError(error) {
    var message = 'Sorry, something went wrong. Please try again.';
    if (error && error.description) message = error.description;
    if (error && error.message) message = error.message;
    showToast(message, 'error');
  }

  function showToast(message, type) {
    var toast = document.createElement('div');
    toast.className = 'cart-toast' + (type === 'error' ? ' cart-toast--error' : '');
    toast.setAttribute('role', 'alert');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 250);
    }, 3500);
  }

  function escapeHtml(value) {
    if (value == null) return '';

    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function thumbUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + 'x$1$2');
  }

  function variantText(item) {
    if (!item.options_with_values || !item.options_with_values.length) {
      return item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    }

    return item.options_with_values
      .map(function (option) { return option.value; })
      .filter(function (value) { return value && value !== 'Default Title'; })
      .join(' / ');
  }

  function lineTemplate(item, index) {
    var compare = item.original_line_price;
    var current = item.final_line_price;
    var isOnSale = compare && compare > current;
    var variantTitle = variantText(item);
    var image = item.image ? thumbUrl(item.image, 180) : '';

    return '' +
      '<div class="cart-line-item" data-line="' + index + '" data-key="' + escapeHtml(item.key) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="cart-line-item__image" tabindex="-1">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title) + '" width="88" height="88" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-line-item__info">' +
          '<a href="' + escapeHtml(item.url) + '" class="cart-line-item__title">' + escapeHtml(item.product_title) + '</a>' +
          (variantTitle ? '<span class="cart-line-item__variant">' + escapeHtml(variantTitle) + '</span>' : '') +
        '</div>' +
        '<span class="cart-line-item__price">' +
          (isOnSale ? '<span class="cart-line-item__price-compare">' + formatMoney(compare) + '</span>' : '') +
          '<span>' + formatMoney(current) + '</span>' +
        '</span>' +
        '<div class="cart-line-item__actions">' +
          '<div class="cart-line-item__quantity" aria-label="Quantity controls">' +
            '<button type="button" data-cart-quantity-change="-1" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" fill="none"><path d="M2.5 6h7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>' +
            '<span aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-cart-quantity-change="1" aria-label="Increase quantity"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" fill="none"><path d="M6 2.5v7M2.5 6h7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>' +
          '</div>' +
          '<button type="button" class="cart-line-item__remove" data-cart-remove aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" fill="none">' +
              '<path d="M2.5 3.5h9M5.5 3.5V2.25h3V3.5M4 5v7h6V5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            '<span>Remove</span>' +
          '</button>' +
        '</div>' +
      '</div>';
  }

  var GIFT_ICON = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3.5 9h13v7.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V9Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M2.75 6.25h14.5V9H2.75z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M10 6.25v11.25M10 6.25c-1.2-.1-3.4-.7-3.4-2.3 0-1.1.9-1.7 1.8-1.7 1.6 0 1.6 2.6 1.6 4Zm0 0c1.2-.1 3.4-.7 3.4-2.3 0-1.1-.9-1.7-1.8-1.7-1.6 0-1.6 2.6-1.6 4Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function giftTemplate(gwp) {
    var cfg = config();
    var expanded = !!state.giftExpanded;
    var meta = gwp.unlocked ? cfg.gwpUnlockedMeta : cfg.gwpLockedMeta;
    var listId = 'cart-gift-list';

    var rows = gwp.giftLines.map(function (item) {
      var image = item.image ? thumbUrl(item.image, 120) : '';
      var qty = item.quantity > 1 ? ' <span class="cart-gift__qty">x' + item.quantity + '</span>' : '';
      return '' +
        '<li class="cart-gift__item" data-key="' + escapeHtml(item.key) + '">' +
          '<span class="cart-gift__thumb">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '<a href="' + escapeHtml(item.url) + '" class="cart-gift__name">' + escapeHtml(item.product_title) + qty + '</a>' +
          '<span class="cart-gift__item-price">' +
            '<s>' + formatMoney(item.original_line_price) + '</s>' +
            '<strong>' + (gwp.unlocked ? 'Free' : 'Free at ' + gwp.values.threshold) + '</strong>' +
          '</span>' +
        '</li>';
    }).join('');

    return '' +
      '<div class="cart-gift' + (gwp.unlocked ? ' is-unlocked' : ' is-locked') + (expanded ? ' is-expanded' : '') + '">' +
        '<button type="button" class="cart-gift__toggle" data-cart-gift-toggle aria-expanded="' + (expanded ? 'true' : 'false') + '" aria-controls="' + listId + '">' +
          '<span class="cart-gift__icon">' + GIFT_ICON + '</span>' +
          '<span class="cart-gift__info">' +
            '<span class="cart-gift__title">' + escapeHtml(fillTemplate(cfg.gwpTitle, gwp.values)) + '</span>' +
            (meta ? '<span class="cart-gift__meta">' + escapeHtml(fillTemplate(meta, gwp.values)) + '</span>' : '') +
          '</span>' +
          '<span class="cart-gift__price">' +
            '<s>' + formatMoney(gwp.giftValue) + '</s>' +
            '<strong>' + (gwp.unlocked ? 'Free' : 'Locked') + '</strong>' +
          '</span>' +
          '<span class="cart-gift__chevron" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 5.25 7 9.25l4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '</button>' +
        '<div class="cart-gift__body" id="' + listId + '"' + (expanded ? '' : ' hidden') + '>' +
          '<ul class="cart-gift__list">' + rows + '</ul>' +
          '<button type="button" class="cart-gift__remove" data-cart-gift-remove>' + escapeHtml(cfg.gwpRemoveLabel) + '</button>' +
        '</div>' +
      '</div>';
  }

  function render() {
    var drawer = drawerEl();
    if (!drawer) return;

    var items = drawer.querySelector(SELECTORS.itemsContainer);
    var giftWrap = drawer.querySelector('[data-cart-gift]');
    var footer = drawer.querySelector(SELECTORS.footer);
    var gwp = computeGwp(state.cart);
    state.gwp = gwp;

    if (!state.cart || state.cart.item_count === 0) {
      if (items) items.innerHTML = '';
      if (giftWrap) { giftWrap.innerHTML = ''; giftWrap.hidden = true; }
      drawer.classList.add('is-empty');
      drawer.classList.remove('has-gift', 'gift-only');
      if (footer) footer.hidden = true;
      hideGiftGuard();
      updateProgress(0, gwp);
      state.displayCount = 0;
      broadcast(gwp);
      settle();
      return;
    }

    drawer.classList.remove('is-empty');
    drawer.classList.toggle('has-gift', gwp.active);
    drawer.classList.toggle('gift-only', gwp.active && !gwp.paidLines.length);
    if (footer) footer.hidden = false;

    if (items) {
      items.innerHTML = gwp.paidLines.map(function (item, index) {
        return lineTemplate(item, index + 1);
      }).join('');
    }

    if (giftWrap) {
      var giftHtml = gwp.active ? giftTemplate(gwp) : '';
      var ev = gwp.engine;
      if (ev && ev.hasConfig) {
        giftHtml += ev.rules.map(function (r) {
          if (!r.winner || r.dismissed) return '';
          if (!r.present.length && r.mode !== 'CHOOSE') return '';
          return window.GeskeGwp.templates.group(r);
        }).join('');
      }
      if (giftHtml) {
        giftWrap.innerHTML = giftHtml;
        giftWrap.hidden = false;
      } else {
        giftWrap.innerHTML = '';
        giftWrap.hidden = true;
      }
    }

    // The provisional bundle counts as one thing in the badge, and its full
    // price is left out of the subtotal: whichever way the order goes (unlocked
    // and free, or removed at checkout) the customer never pays for it. Rule
    // gifts count once each and their (normally zero) charge is hidden too.
    var engineEv = gwp.engine;
    var managedCount = engineEv ? engineEv.managedLines.length : 0;
    var engineCharge = engineEv ? engineEv.giftCharge : 0;
    var displayCount = (gwp.active ? gwp.paidCount + 1 : gwp.paidCount) + managedCount;
    var displayTotal = Math.max(0, state.cart.total_price - (gwp.active ? gwp.giftCharge : 0) - engineCharge);
    state.displayCount = displayCount;
    drawer.classList.toggle('has-gift', gwp.active || managedCount > 0);

    drawer.querySelectorAll(SELECTORS.countBadge).forEach(function (element) {
      element.textContent = displayCount;
    });

    drawer.querySelectorAll(SELECTORS.subtotal).forEach(function (element) {
      element.textContent = formatMoney(displayTotal);
    });

    renderDiscountRow(drawer);
    renderCheckoutButton(drawer, gwp);
    renderChooseNudge(drawer);
    hideGiftGuard();

    updateProgress(displayTotal, gwp);
    broadcast(gwp);
    settle();
  }

  // Gift only in the bag (straight after the landing page signup): the primary
  // action is to go and choose a device, not to check out an empty order.
  function renderCheckoutButton(drawer, gwp) {
    var button = drawer.querySelector('[data-cart-view-bag]');
    if (!button) return;
    var label = button.querySelector('[data-cart-view-bag-label]');
    if (!button._defaultLabel && label) button._defaultLabel = label.textContent;

    if (gwp.active && !gwp.paidLines.length) {
      button.setAttribute('href', gwp.shopUrl);
      button.classList.add('is-shop-link');
      if (label) label.textContent = gwp.shopLabel;
    } else {
      button.setAttribute('href', '/checkout');
      button.classList.remove('is-shop-link');
      if (label && button._defaultLabel) label.textContent = button._defaultLabel;
    }
  }

  // A line above the checkout button while an unlocked CHOOSE gift is still
  // unchosen, so the chooser interrupt on checkout is never a surprise.
  function renderChooseNudge(drawer) {
    var nudge = drawer.querySelector('[data-gwp-checkout-nudge]');
    if (!nudge) return;
    var gwpEngine = engine();
    var ev = state.gwp && state.gwp.engine;
    var pending = gwpEngine && gwpEngine.needsChoice && ev ? gwpEngine.needsChoice(ev) : [];
    if (pending.length) {
      nudge.textContent = pending[0].messages.chooserHeading;
      nudge.hidden = false;
    } else {
      nudge.textContent = '';
      nudge.hidden = true;
    }
  }

  function hideGiftGuard() {
    var drawer = drawerEl();
    var guard = drawer && drawer.querySelector('[data-gift-guard]');
    if (guard) guard.hidden = true;
    if (drawer) drawer.classList.remove('is-guarding');
  }

  var STALLED_GUARD_TEXT = 'Your free gift is not discounting with the code applied to this order. Remove the code to keep the gift, or check out without it.';

  function showGiftGuard(gwp, textOverride) {
    var drawer = drawerEl();
    var guard = drawer && drawer.querySelector('[data-gift-guard]');
    if (!guard) return false;
    var text = guard.querySelector('[data-gift-guard-text]');
    if (text) text.textContent = textOverride || fillTemplate(config().gwpGuard, gwp && gwp.values ? gwp.values : {});
    guard.hidden = false;
    drawer.classList.add('is-guarding');
    var keep = guard.querySelector('[data-gift-guard-keep]');
    if (keep) keep.focus({ preventScroll: true });
    return true;
  }

  function removeGiftLines(extraKeys) {
    var gwp = state.gwp;
    var updates = {};
    if (gwp && gwp.active) gwp.giftLines.forEach(function (item) { updates[item.key] = 0; });
    (extraKeys || []).forEach(function (key) { updates[key] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(state.cart);

    return enqueue(function () {
      var drawer = drawerEl();
      state.loading = true;
      if (drawer) drawer.classList.add('is-updating');
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) { throw error; });
          }
          return response.json();
        })
        .then(function (cart) {
          state.cart = cart;
          render();
          updateHeaderBadge();
          return cart;
        })
        .catch(handleError)
        .finally(function () {
          state.loading = false;
          if (drawer) drawer.classList.remove('is-updating');
        });
    });
  }

  function renderDiscountRow(drawer) {
    var row = drawer.querySelector('[data-cart-discount-row]');
    if (!row) return;

    // Line-level discount codes already show per item as struck-through
    // prices, so only cart-level applications need their own row. Without it
    // the net subtotal reads lower than the sum of the visible line prices.
    var applications = state.cart.cart_level_discount_applications || [];
    var amount = applications.reduce(function (sum, application) {
      return sum + (application.total_allocated_amount || 0);
    }, 0);

    if (amount <= 0) {
      row.hidden = true;
      return;
    }

    var titles = applications
      .map(function (application) { return application.title; })
      .filter(Boolean)
      .join(', ');

    var label = row.querySelector('[data-cart-discount-label]');
    var value = row.querySelector('[data-cart-discount-value]');
    if (label) label.textContent = titles ? 'Discount (' + titles + ')' : 'Discount';
    if (value) value.textContent = '-' + formatMoney(amount);
    row.hidden = false;
  }

  function updateProgress(total, gwp) {
    var drawer = drawerEl();
    if (!drawer) return;

    var cfg = config();
    var fill = drawer.querySelector(SELECTORS.progressFill);
    var text = drawer.querySelector(SELECTORS.progressText);
    if (!fill || !text) return;

    // Gift mode: the meter tracks eligible spend towards the gift threshold
    // instead of free delivery (the gift threshold sits above the delivery one,
    // so hitting it covers both).
    if (gwp && gwp.active && gwp.threshold > 0) {
      drawer.classList.add('is-gift-progress');
      if (gwp.unlocked) {
        fill.style.width = '100%';
        text.textContent = fillTemplate(cfg.gwpComplete, gwp.values);
        drawer.classList.add('is-qualified');
      } else {
        fill.style.width = gwp.progress + '%';
        text.textContent = fillTemplate(cfg.gwpPending, gwp.values);
        drawer.classList.remove('is-qualified');
      }
      return;
    }

    // Rule-driven gifts: the meter walks the customer to the nearest unmet
    // spend threshold (gift or free delivery, per the app's priority setting),
    // then celebrates the unlocked gift.
    var ev = gwp && gwp.engine;
    if (ev && ev.hasConfig) {
      var settings = (window.GeskeGwp.config() || {}).settings || {};
      var deliveryPending = cfg.threshold > 0 && total < cfg.threshold;
      var next = ev.next;
      var showGift = false;
      if (next && deliveryPending) {
        showGift = settings.progressPriority !== 'DELIVERY_FIRST';
      } else if (next) {
        showGift = true;
      }
      if (showGift) {
        drawer.classList.add('is-gift-progress');
        drawer.classList.remove('is-qualified');
        fill.style.width = next.progress + '%';
        text.textContent = next.messages.pending;
        return;
      }
      if (!deliveryPending && ev.unlockedTop && !ev.guard.needed) {
        drawer.classList.add('is-gift-progress', 'is-qualified');
        fill.style.width = '100%';
        text.textContent = ev.unlockedTop.status === 'UNLOCKED_CHOOSE'
          ? ev.unlockedTop.messages.chooserHeading
          : ev.unlockedTop.messages.unlocked;
        return;
      }
    }
    drawer.classList.remove('is-gift-progress');

    if (cfg.threshold <= 0 || total >= cfg.threshold) {
      fill.style.width = '100%';
      text.textContent = cfg.progressComplete || '';
      drawer.classList.add('is-qualified');
      return;
    }

    fill.style.width = Math.max(0, Math.min(100, (total / cfg.threshold) * 100)) + '%';
    text.textContent = (cfg.progressPending || '').replace('{amount}', formatMoney(cfg.threshold - total));
    drawer.classList.remove('is-qualified');
  }

  function updateHeaderBadge() {
    if (!state.cart) return;

    var gwp = state.gwp || computeGwp(state.cart);
    var count = typeof state.displayCount === 'number'
      ? state.displayCount
      : (gwp.active ? gwp.paidCount + 1 : state.cart.item_count);

    document.querySelectorAll(SELECTORS.headerCount).forEach(function (element) {
      element.textContent = count;
      element.classList.toggle('hidden', count === 0);
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableInDrawer() {
    var drawer = drawerEl();
    if (!drawer) return [];
    var panel = drawer.querySelector('.cart-drawer__panel') || drawer;
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (element) {
      return element.offsetParent !== null || element === document.activeElement;
    });
  }

  function trapFocus(event) {
    if (!state.open || event.key !== 'Tab') return;

    var focusable = focusableInDrawer();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;

    // Remember what opened the drawer so focus can return there on close.
    if (!state.open) {
      state.trigger = document.activeElement;
    }

    var titleEl = drawer.querySelector(SELECTORS.title);
    if (titleEl) titleEl.textContent = config().titleCart;

    // Capture scroll position, then pin the body (see body.drawer-open in
    // geske-cart.css) so iOS Safari keeps its place when the drawer closes. (CART3)
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.top = '-' + state.scrollY + 'px';
    document.body.classList.add('drawer-open');
    state.open = true;

    var closeButton = drawer.querySelector('.cart-drawer__close');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY || 0);
    state.open = false;

    var trigger = state.trigger;
    state.trigger = null;
    if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }
  }

  function refreshAndMaybeOpen(shouldOpen) {
    return fetchCart().then(function () {
      render();
      updateHeaderBadge();
      if (shouldOpen) openDrawer();
    });
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest(SELECTORS.cartToggle);
      if (!toggle) return;

      event.preventDefault();
      refreshAndMaybeOpen(true);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest(SELECTORS.close)) closeDrawer();
    });

    document.addEventListener('click', function (event) {
      var quantityButton = event.target.closest(SELECTORS.quantityButton);
      if (!quantityButton) return;

      var lineItem = quantityButton.closest('.cart-line-item');
      if (!lineItem || !lineItem.dataset.key) return;

      var item = state.cart && state.cart.items.find(function (cartItem) {
        return cartItem.key === lineItem.dataset.key;
      });
      if (!item) return;

      var delta = parseInt(quantityButton.getAttribute('data-cart-quantity-change'), 10);
      var nextQuantity = Math.max(0, item.quantity + delta);

      event.preventDefault();
      changeItem(item.key, nextQuantity);
    });

    document.addEventListener('click', function (event) {
      var removeButton = event.target.closest(SELECTORS.removeButton);
      if (!removeButton) return;

      var lineItem = removeButton.closest('.cart-line-item');
      if (!lineItem || !lineItem.dataset.key) return;

      event.preventDefault();
      changeItem(lineItem.dataset.key, 0);
    });

    // Gift bundle group: expand/collapse the item list, remove the whole bundle.
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-gift-toggle]');
      if (!toggle) return;
      event.preventDefault();
      var group = toggle.closest('.cart-gift');
      var body = group && group.querySelector('.cart-gift__body');
      state.giftExpanded = !state.giftExpanded;
      toggle.setAttribute('aria-expanded', state.giftExpanded ? 'true' : 'false');
      if (group) group.classList.toggle('is-expanded', state.giftExpanded);
      if (body) body.hidden = !state.giftExpanded;
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-gift-remove]');
      if (!remove) return;
      event.preventDefault();
      removeGiftLines();
    });

    // Checkout with a locked gift would charge full price for the "free" lines,
    // so stop and let the customer choose.
    document.addEventListener('click', function (event) {
      var checkout = event.target.closest('[data-cart-view-bag]');
      if (!checkout || checkout.classList.contains('is-shop-link')) return;
      var gwp = state.gwp;
      if (gwp && gwp.active && !gwp.unlocked) {
        if (showGiftGuard(gwp)) event.preventDefault();
        return;
      }
      // A rule gift that Shopify is still charging for (a code that doesn't
      // combine): never send the customer to pay for a "free" item.
      var ev = gwp && gwp.engine;
      if (ev && ev.guard.needed) {
        if (showGiftGuard(gwp, STALLED_GUARD_TEXT)) event.preventDefault();
        return;
      }
      // An unlocked CHOOSE rule with nothing picked: interrupt once with the
      // chooser modal. Picking continues straight to checkout; skipping is
      // never remembered, so the customer is simply asked again next time.
      var gwpEngine = engine();
      if (gwpEngine && gwpEngine.needsChoice && ev && gwpEngine.needsChoice(ev).length) {
        event.preventDefault();
        gwpEngine.chooser.open({ context: 'checkout' });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-gift-guard-keep]')) {
        event.preventDefault();
        hideGiftGuard();
        closeDrawer();
        return;
      }
      var skip = event.target.closest('[data-gift-guard-skip]');
      if (!skip) return;
      event.preventDefault();
      skip.disabled = true;
      var stalledKeys = [];
      var ev = state.gwp && state.gwp.engine;
      if (ev && ev.guard.needed) {
        ev.rules.forEach(function (r) {
          if (!r.stalled) return;
          r.present.forEach(function (item) { stalledKeys.push(item.key); });
        });
      }
      removeGiftLines(stalledKeys).then(function () {
        window.location.href = '/checkout';
      });
    });

    // Rule gifts: open the chooser modal (CHOOSE mode selection lives there),
    // remove a gift (remembered for the session), or pick a tile. All go
    // through the engine so the desired state stays consistent with what the
    // cart page would do. The modal handles its own tiles and stops
    // propagation, so the [data-gwp-choose] branch here only serves tiles
    // rendered outside it.
    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-gwp-open-chooser]');
      if (openBtn) {
        var chooserEngine = engine();
        if (!chooserEngine || !chooserEngine.chooser) return;
        event.preventDefault();
        chooserEngine.chooser.open({ handles: [openBtn.getAttribute('data-gwp-open-chooser')], context: 'browse' });
        return;
      }
      var dismissBtn = event.target.closest('[data-gwp-dismiss]');
      var chooseBtn = event.target.closest('[data-gwp-choose]');
      if (!dismissBtn && !chooseBtn) return;
      var gwpEngine = engine();
      if (!gwpEngine) return;
      event.preventDefault();
      var drawer = drawerEl();
      if (drawer) drawer.classList.add('is-updating');
      var action = dismissBtn
        ? gwpEngine.dismiss(dismissBtn.getAttribute('data-gwp-dismiss'))
        : gwpEngine.choose(chooseBtn.getAttribute('data-gwp-choose'), chooseBtn.getAttribute('data-variant-id'));
      action.then(function (result) {
        if (result && result.cart) state.cart = result.cart;
        render();
        updateHeaderBadge();
      }).catch(handleError).finally(function () {
        if (drawer) drawer.classList.remove('is-updating');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.open) {
        closeDrawer();
        return;
      }
      trapFocus(event);
    });

    document.addEventListener('cart:update', function (event) {
      if (event.detail && event.detail.data && event.detail.data.didError) return;
      // The gift engine's own mutations should not pop the drawer open.
      var fromEngine = event.detail && event.detail.data && event.detail.data.source === 'gwp-engine';
      refreshAndMaybeOpen(fromEngine ? false : config().autoOpen);
    });

    // Coming back from checkout with the browser back button restores this
    // page from the back/forward cache, so the drawer still holds the cart
    // fetched before checkout. A discount code applied there changes the net
    // total (/cart.js total_price), which decides the free delivery meter, so
    // refetch on restore instead of trusting the cached state.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshAndMaybeOpen(false);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest(SELECTORS.productForm);
      if (!form) return;
      if (form.closest('product-form-component')) return;

      event.preventDefault();

      var variantInput = form.querySelector('input[name="id"], [data-variant-id]');
      if (!variantInput) return;

      var button = form.querySelector(SELECTORS.addToCartBtn) || form.querySelector('button[type="submit"]');
      var textEl = form.querySelector(SELECTORS.addToCartText);
      var originalLabel = textEl ? textEl.textContent : '';

      if (button) button.disabled = true;
      if (textEl) textEl.textContent = 'Adding...';

      addItem(variantInput.value, 1).then(function (success) {
        if (success && textEl) textEl.textContent = 'Added';

        if (!success) {
          if (textEl) textEl.textContent = originalLabel;
          if (button) button.disabled = false;
          return;
        }

        setTimeout(function () {
          if (textEl) textEl.textContent = originalLabel;
          if (button) button.disabled = false;
        }, 1400);
      });
    });

    document.addEventListener('click', function (event) {
      var atc = event.target.closest(SELECTORS.collectionCardAtc);
      if (!atc) return;

      event.preventDefault();
      event.stopPropagation();

      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId) return;

      atc.disabled = true;
      atc.classList.add('is-loading');

      addItem(variantId, 1).then(function (success) {
        atc.classList.remove('is-loading');
        atc.disabled = false;

        if (!success) return;

        atc.classList.add('is-added');
        setTimeout(function () {
          atc.classList.remove('is-added');
        }, 1400);
      });
    });
  }

  var ARRIVAL_KEY = 'geske-gwp-arrival';

  // If the gift lines are in the bag but the code is not on the cart session
  // (blocked fetch at signup, cleared cookies), re-prime it once so the bundle
  // actually zeroes out at checkout when the threshold is reached.
  function ensureGiftCode(gwp) {
    if (!gwp || !gwp.active || gwp.codeAttached || !gwp.code || state.codePrimed) return Promise.resolve();
    if (!/^[A-Za-z0-9_-]{2,40}$/.test(gwp.code)) return Promise.resolve();
    state.codePrimed = true;
    return fetch('/discount/' + encodeURIComponent(gwp.code), { credentials: 'same-origin' })
      .then(function () { return fetchCart(); })
      .then(function () { render(); })
      .catch(function () { /* the code still works when typed at checkout */ });
  }

  function init() {
    if (!drawerEl()) return;

    var arrived = false;
    try {
      arrived = window.sessionStorage.getItem(ARRIVAL_KEY) === '1';
      if (arrived) window.sessionStorage.removeItem(ARRIVAL_KEY);
    } catch (error) {
      /* storage blocked */
    }

    refreshAndMaybeOpen(false).then(function () {
      var gwp = state.gwp || computeGwp(state.cart);
      // Landing page signup redirects here with the bundle in the bag: open the
      // drawer once so the customer sees the gift and the meter to unlock it.
      if (arrived && gwp.active) openDrawer();
      return ensureGiftCode(gwp);
    });
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.GeskeCart = {
    open: function () { openDrawer(); },
    close: closeDrawer,
    add: addItem,
    refresh: function () { return refreshAndMaybeOpen(false); },
    // Current gift-with-purchase summary (see computeGwp); null before first fetch.
    gwp: function () { return state.gwp || null; },
    // Rule-driven gift evaluation from geske-gwp-engine.js (null when no rules).
    engine: function () { return state.gwp && state.gwp.engine ? state.gwp.engine : null; },
    formatMoney: formatMoney,
    formatMoneyShort: formatMoneyShort,
    fillTemplate: fillTemplate
  };
})();
